"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f115 = void 0;
exports.f115 = {
    "sa": [
        "Deva",
        "Gran",
        "Mymr",
        "Nand",
        "Newa",
        "Shrd",
        "Sidd",
        "Sinh"
    ],
    "saa": [
        "Latn"
    ],
    "sab": [
        "Latn"
    ],
    "sac": [
        "Latn"
    ],
    "sad": [
        "Latn"
    ],
    "sae": [
        "Latn"
    ],
    "saf": [
        "Latn"
    ],
    "sah": [
        "Cyrl",
        "Cyrs"
    ],
    "saj": [
        "Latn"
    ],
    "sak": [
        "Latn"
    ],
    "sam": [
        "Samr",
        "Hebr",
        "Syrc"
    ],
    "sao": [
        "Latn"
    ],
    "saq": [
        "Latn"
    ],
    "sar": [
        "Latn"
    ],
    "sas": [
        "Latn",
        "Bali"
    ],
    "sat": [
        "Latn",
        "Beng",
        "Deva",
        "Olck",
        "Orya"
    ],
    "sau": [
        "Latn"
    ],
    "sav": [
        "Latn",
        "Arab"
    ],
    "saw": [
        "Latn"
    ],
    "sax": [
        "Latn"
    ],
    "say": [
        "Latn"
    ],
    "saz": [
        "Saur",
        "Deva",
        "Taml",
        "Telu"
    ],
    "sba": [
        "Latn"
    ],
    "sbb": [
        "Latn"
    ],
    "sbc": [
        "Latn"
    ],
    "sbd": [
        "Latn"
    ],
    "sbe": [
        "Latn"
    ],
    "sbf": [
        "Zyyy"
    ],
    "sbg": [
        "Latn"
    ],
    "sbh": [
        "Latn"
    ],
    "sbi": [
        "Latn"
    ],
    "sbj": [
        "Latn"
    ],
    "sbk": [
        "Latn"
    ],
    "sbl": [
        "Latn"
    ],
    "sbm": [
        "Latn"
    ],
    "sbn": [
        "Arab"
    ],
    "sbo": [
        "Latn"
    ],
    "sbp": [
        "Latn"
    ],
    "sbq": [
        "Latn"
    ],
    "sbr": [
        "Latn"
    ],
    "sbs": [
        "Latn"
    ],
    "sbt": [
        "Latn"
    ],
    "sbu": [
        "Deva",
        "Tibt"
    ],
    "sbv": [
        "Zyyy"
    ],
    "sbw": [
        "Latn"
    ],
    "sbx": [
        "Latn"
    ],
    "sby": [
        "Latn"
    ],
    "sbz": [
        "Latn"
    ],
    "sc": [
        "Latn"
    ],
    "scb": [
        "Latn"
    ],
    "sce": [
        "Latn",
        "Arab"
    ],
    "scf": [
        "Latn"
    ],
    "scg": [
        "Latn"
    ],
    "sch": [
        "Latn"
    ],
    "sci": [
        "Latn"
    ],
    "sck": [
        "Deva",
        "Beng"
    ],
    "scl": [
        "Arab"
    ],
    "scn": [
        "Latn"
    ],
    "sco": [
        "Latn"
    ],
    "scp": [
        "Deva"
    ],
    "scq": [
        "Zyyy"
    ],
    "scs": [
        "Latn",
        "Cans"
    ],
    "sct": [
        "Laoo"
    ],
    "scu": [
        "Takr"
    ],
    "scv": [
        "Latn"
    ],
    "scw": [
        "Latn"
    ],
    "scx": [
        "Grek"
    ],
    "sd": [
        "Arab",
        "Deva",
        "Guru",
        "Khoj",
        "Sind"
    ],
    "sda": [
        "Latn"
    ],
    "sdb": [
        "Arab"
    ],
    "sdc": [
        "Latn"
    ],
    "sde": [
        "Latn"
    ],
    "sdf": [
        "Zyyy"
    ],
    "sdg": [
        "Arab"
    ],
    "sdh": [
        "Arab"
    ],
    "sdj": [
        "Latn"
    ],
    "sdk": [
        "Latn"
    ],
    "sdl": [
        "Zxxx"
    ],
    "sdm": [
        "Latn"
    ],
    "sdn": [
        "Latn"
    ],
    "sdo": [
        "Latn"
    ],
    "sdp": [
        "Zyyy"
    ],
    "sdq": [
        "Latn"
    ],
    "sdr": [
        "Beng",
        "Deva",
        "Latn"
    ],
    "sds": [
        "Arab"
    ],
    "sdt": [
        "Zyyy"
    ],
    "sdu": [
        "Latn"
    ],
    "sdx": [
        "Latn"
    ],
    "sdz": [
        "Zyyy"
    ],
    "se": [
        "Latn",
        "Cyrl"
    ],
    "sea": [
        "Latn"
    ],
    "seb": [
        "Latn"
    ],
    "sec": [
        "Latn"
    ],
    "sed": [
        "Latn"
    ],
    "see": [
        "Latn"
    ],
    "sef": [
        "Latn"
    ],
    "seg": [
        "Latn"
    ],
    "seh": [
        "Latn"
    ],
    "sei": [
        "Latn"
    ],
    "sej": [
        "Latn"
    ],
    "sek": [
        "Latn",
        "Cans"
    ],
    "sel": [
        "Cyrl"
    ],
    "sen": [
        "Latn"
    ],
    "seo": [
        "Latn"
    ],
    "sep": [
        "Latn"
    ],
    "seq": [
        "Latn"
    ],
    "ser": [
        "Latn"
    ],
    "ses": [
        "Latn"
    ],
    "set": [
        "Latn"
    ],
    "seu": [
        "Latn"
    ],
    "sev": [
        "Latn"
    ],
    "sew": [
        "Latn"
    ],
    "sey": [
        "Latn"
    ],
    "sez": [
        "Latn"
    ],
    "sfb": [
        "Zxxx"
    ],
    "sfe": [
        "Latn"
    ],
    "sfm": [
        "Plrd"
    ],
    "sfs": [
        "Zxxx"
    ],
    "sfw": [
        "Latn"
    ],
    "sg": [
        "Latn"
    ],
    "sga": [
        "Ogam",
        "Latn"
    ],
    "sgb": [
        "Latn"
    ],
    "sgc": [
        "Latn"
    ],
    "sgd": [
        "Latn"
    ],
    "sge": [
        "Latn"
    ],
    "sgg": [
        "Zxxx"
    ],
    "sgh": [
        "Arab",
        "Cyrl",
        "Latn"
    ],
    "sgi": [
        "Latn"
    ],
    "sgj": [
        "Deva"
    ],
    "sgk": [
        "Zyyy"
    ],
    "sgm": [
        "Latn"
    ],
    "sgn": [
        "Zxxx"
    ],
    "sgp": [
        "Latn"
    ],
    "sgr": [
        "Arab"
    ],
    "sgs": [
        "Latn"
    ],
    "sgt": [
        "Tibt"
    ],
    "sgu": [
        "Latn"
    ],
    "sgw": [
        "Ethi"
    ],
    "sgx": [
        "Zxxx"
    ],
    "sgy": [
        "Arab"
    ],
    "sgz": [
        "Latn"
    ],
    "sh": [
        "Latn"
    ],
    "sha": [
        "Latn"
    ],
    "shb": [
        "Latn"
    ],
    "shc": [
        "Latn"
    ],
    "shd": [
        "Arab"
    ],
    "she": [
        "Latn"
    ],
    "shg": [
        "Latn"
    ],
    "shh": [
        "Latn"
    ],
    "shi": [
        "Tfng",
        "Arab",
        "Latn"
    ],
    "shj": [
        "Latn"
    ],
    "shk": [
        "Latn",
        "Arab"
    ],
    "shl": [
        "Zyyy"
    ],
    "shm": [
        "Arab"
    ],
    "shn": [
        "Mymr",
        "Tale",
        "Thai"
    ],
    "sho": [
        "Latn"
    ],
    "shp": [
        "Latn"
    ],
    "shq": [
        "Latn"
    ],
    "shr": [
        "Latn"
    ],
    "shs": [
        "Latn"
    ],
    "sht": [
        "Latn"
    ],
    "shu": [
        "Arab",
        "Latn"
    ],
    "shv": [
        "Zyyy"
    ],
    "shw": [
        "Latn"
    ],
    "shx": [
        "Zyyy"
    ],
    "shy": [
        "Arab",
        "Latn",
        "Tfng"
    ],
    "shz": [
        "Latn"
    ],
    "si": [
        "Sinh",
        "Brai"
    ],
    "sia": [
        "Cyrl"
    ],
    "sib": [
        "Latn"
    ],
    "sid": [
        "Latn",
        "Ethi"
    ],
    "sie": [
        "Latn"
    ],
    "sif": [
        "Latn"
    ],
    "sig": [
        "Latn"
    ],
    "sih": [
        "Latn"
    ],
    "sii": [
        "Zyyy"
    ],
    "sij": [
        "Latn"
    ],
    "sik": [
        "Latn"
    ],
    "sil": [
        "Latn"
    ],
    "sim": [
        "Latn"
    ],
    "sip": [
        "Tibt"
    ],
    "siq": [
        "Latn"
    ],
    "sir": [
        "Latn"
    ],
    "sis": [
        "Zyyy"
    ],
    "siu": [
        "Latn"
    ],
    "siv": [
        "Latn"
    ],
    "siw": [
        "Latn"
    ],
    "six": [
        "Latn"
    ],
    "siy": [
        "Zyyy"
    ],
    "siz": [
        "Arab"
    ],
    "sja": [
        "Latn"
    ],
    "sjb": [
        "Latn"
    ],
    "sjd": [
        "Cyrl"
    ],
    "sje": [
        "Latn"
    ],
    "sjg": [
        "Latn"
    ],
    "sjk": [
        "Latn"
    ],
    "sjl": [
        "Latn"
    ],
    "sjm": [
        "Latn"
    ],
    "sjn": [
        "Teng",
        "Cirt"
    ],
    "sjo": [
        "Mong",
        "Cyrl",
        "Latn"
    ],
    "sjp": [
        "Deva",
        "Beng"
    ],
    "sjr": [
        "Latn"
    ],
    "sjs": [
        "Zyyy"
    ],
    "sjt": [
        "Cyrl"
    ],
    "sju": [
        "Latn"
    ],
    "sjw": [
        "Latn"
    ],
    "sk": [
        "Latn",
        "Brai"
    ],
    "ska": [
        "Latn"
    ],
    "skb": [
        "Thai"
    ],
    "skc": [
        "Latn"
    ],
    "skd": [
        "Latn"
    ],
    "ske": [
        "Latn"
    ],
    "skf": [
        "Latn"
    ],
    "skg": [
        "Latn"
    ],
    "skh": [
        "Latn"
    ],
    "ski": [
        "Latn"
    ],
    "skj": [
        "Deva"
    ],
    "skm": [
        "Latn"
    ],
    "skn": [
        "Latn"
    ],
    "sko": [
        "Latn"
    ],
    "skp": [
        "Latn"
    ],
    "skq": [
        "Latn"
    ],
    "skr": [
        "Arab",
        "Deva",
        "Guru",
        "Khoj"
    ],
    "sks": [
        "Latn"
    ],
    "skt": [
        "Latn"
    ],
    "sku": [
        "Latn"
    ],
    "skv": [
        "Latn"
    ],
    "skw": [
        "Latn"
    ],
    "skx": [
        "Latn"
    ],
    "sky": [
        "Latn"
    ],
    "skz": [
        "Latn"
    ],
    "sl": [
        "Latn",
        "Brai"
    ],
    "slc": [
        "Latn"
    ],
    "sld": [
        "Latn"
    ],
    "sle": [
        "Zyyy"
    ],
    "slf": [
        "Zxxx"
    ],
    "slg": [
        "Latn"
    ],
    "slh": [
        "Latn"
    ],
    "sli": [
        "Latn"
    ],
    "slj": [
        "Latn"
    ],
    "sll": [
        "Latn"
    ],
    "slm": [
        "Latn"
    ],
    "sln": [
        "Latn"
    ],
    "slp": [
        "Latn"
    ],
    "slq": [
        "Arab"
    ],
    "slr": [
        "Latn"
    ],
    "sls": [
        "Zxxx"
    ],
    "slt": [
        "Zyyy"
    ],
    "slu": [
        "Latn"
    ],
    "slw": [
        "Latn"
    ],
    "slx": [
        "Latn"
    ],
    "sly": [
        "Latn"
    ],
    "slz": [
        "Latn"
    ],
    "sm": [
        "Latn"
    ],
    "sma": [
        "Latn"
    ],
    "smb": [
        "Latn"
    ],
    "smc": [
        "Latn"
    ],
    "smd": [
        "Latn"
    ],
    "smf": [
        "Latn"
    ],
    "smg": [
        "Latn"
    ],
    "smh": [
        "Yiii"
    ],
    "smj": [
        "Latn"
    ],
    "smk": [
        "Latn"
    ],
    "sml": [
        "Latn"
    ],
    "smm": [
        "Zyyy"
    ],
    "smn": [
        "Latn"
    ],
    "smp": [
        "Samr",
        "Arab",
        "Hebr"
    ],
    "smq": [
        "Latn"
    ],
    "smr": [
        "Latn"
    ],
    "sms": [
        "Latn",
        "Cyrl"
    ],
    "smt": [
        "Latn"
    ],
    "smu": [
        "Khmr"
    ],
    "smv": [
        "Zyyy"
    ],
    "smw": [
        "Latn"
    ],
    "smx": [
        "Latn"
    ],
    "smy": [
        "Arab"
    ],
    "smz": [
        "Latn"
    ],
    "sn": [
        "Latn",
        "Brai"
    ],
    "snb": [
        "Latn"
    ],
    "snc": [
        "Latn"
    ],
    "sne": [
        "Latn"
    ],
    "snf": [
        "Latn"
    ],
    "sng": [
        "Latn",
        "Brai"
    ],
    "snh": [
        "Zyyy"
    ],
    "sni": [
        "Latn"
    ],
    "snj": [
        "Latn"
    ],
    "snk": [
        "Latn",
        "Arab"
    ],
    "snl": [
        "Latn"
    ],
    "snm": [
        "Latn"
    ],
    "snn": [
        "Latn"
    ],
    "sno": [
        "Latn"
    ],
    "snp": [
        "Latn"
    ],
    "snq": [
        "Latn"
    ],
    "snr": [
        "Latn"
    ],
    "sns": [
        "Latn"
    ],
    "snu": [
        "Latn"
    ],
    "snv": [
        "Latn"
    ],
    "snw": [
        "Latn"
    ],
    "snx": [
        "Latn"
    ],
    "sny": [
        "Latn"
    ],
    "snz": [
        "Latn"
    ],
    "so": [
        "Latn",
        "Arab",
        "Osma"
    ],
    "soa": [
        "Tavt",
        "Thai"
    ],
    "sob": [
        "Latn"
    ],
    "soc": [
        "Latn"
    ],
    "sod": [
        "Latn"
    ],
    "soe": [
        "Latn"
    ],
    "sog": [
        "Mani",
        "Sogd",
        "Sogo",
        "Syrc"
    ],
    "soh": [
        "Zyyy"
    ],
    "soi": [
        "Deva"
    ],
    "soj": [
        "Zyyy"
    ],
    "sok": [
        "Latn"
    ],
    "sol": [
        "Latn"
    ],
    "soo": [
        "Latn"
    ],
    "sop": [
        "Latn"
    ],
    "soq": [
        "Latn"
    ],
    "sor": [
        "Latn"
    ],
    "sos": [
        "Latn"
    ],
    "sou": [
        "Thai"
    ],
    "sov": [
        "Latn"
    ],
    "sow": [
        "Latn"
    ],
    "sox": [
        "Latn"
    ],
    "soy": [
        "Latn"
    ],
    "soz": [
        "Latn"
    ],
    "spb": [
        "Latn"
    ],
    "spc": [
        "Latn"
    ],
    "spd": [
        "Latn"
    ],
    "spe": [
        "Latn"
    ],
    "spg": [
        "Latn"
    ],
    "spi": [
        "Latn"
    ],
    "spk": [
        "Latn"
    ],
    "spl": [
        "Latn"
    ],
    "spm": [
        "Latn"
    ],
    "spn": [
        "Latn"
    ],
    "spo": [
        "Latn"
    ],
    "spp": [
        "Latn"
    ],
    "spq": [
        "Latn"
    ],
    "spr": [
        "Latn"
    ],
    "sps": [
        "Latn"
    ],
    "spt": [
        "Tibt"
    ],
    "spu": [
        "Zyyy"
    ],
    "spv": [
        "Orya"
    ],
    "spx": [
        "Zyyy"
    ],
    "sq": [
        "Latn",
        "Brai",
        "Elba",
        "Grek",
        "Vith"
    ],
    "sqa": [
        "Latn"
    ],
    "sqh": [
        "Latn"
    ],
    "sqk": [
        "Zxxx"
    ],
    "sqm": [
        "Latn"
    ],
    "sqn": [
        "Zyyy"
    ],
    "sqo": [
        "Zyyy"
    ],
    "sqq": [
        "Zyyy"
    ],
    "sqr": [
        "Arab"
    ],
    "sqs": [
        "Zxxx"
    ],
    "sqt": [
        "Arab",
        "Latn"
    ],
    "squ": [
        "Latn"
    ],
    "sqx": [
        "Zxxx"
    ],
    "sr": [
        "Cyrl",
        "Brai",
        "Latn"
    ],
    "sra": [
        "Latn"
    ],
    "srb": [
        "Sora",
        "Latn",
        "Orya",
        "Telu"
    ],
    "sre": [
        "Latn"
    ],
    "srf": [
        "Latn"
    ],
    "srg": [
        "Latn"
    ],
    "srh": [
        "Arab"
    ],
    "sri": [
        "Latn"
    ],
    "srk": [
        "Latn"
    ],
    "srl": [
        "Latn"
    ],
    "srm": [
        "Latn"
    ],
    "srn": [
        "Latn"
    ],
    "sro": [
        "Latn"
    ],
    "srq": [
        "Latn"
    ],
    "srr": [
        "Latn",
        "Arab"
    ],
    "srs": [
        "Latn"
    ],
    "srt": [
        "Latn"
    ],
    "sru": [
        "Latn"
    ],
    "srv": [
        "Latn"
    ],
    "srw": [
        "Latn"
    ],
    "srx": [
        "Deva",
        "Takr"
    ],
    "sry": [
        "Latn"
    ],
    "srz": [
        "Arab"
    ],
    "ss": [
        "Latn"
    ],
    "ssb": [
        "Latn"
    ],
    "ssc": [
        "Latn"
    ],
    "ssd": [
        "Latn"
    ],
    "sse": [
        "Latn",
        "Arab"
    ],
    "ssf": [
        "Latn"
    ],
    "ssg": [
        "Latn"
    ],
    "ssh": [
        "Arab"
    ],
    "ssi": [
        "Zyyy"
    ],
    "ssj": [
        "Latn"
    ],
    "ssk": [
        "Zyyy"
    ],
    "ssl": [
        "Latn"
    ],
    "ssm": [
        "Latn"
    ],
    "ssn": [
        "Latn"
    ],
    "sso": [
        "Latn"
    ],
    "ssp": [
        "Zxxx"
    ],
    "ssq": [
        "Latn"
    ],
    "ssr": [
        "Zxxx"
    ],
    "sss": [
        "Laoo",
        "Thai"
    ],
    "sst": [
        "Latn"
    ],
    "ssu": [
        "Latn"
    ],
    "ssv": [
        "Latn"
    ],
    "ssx": [
        "Latn"
    ],
    "ssy": [
        "Latn",
        "Ethi"
    ],
    "ssz": [
        "Latn"
    ],
    "st": [
        "Latn"
    ],
    "sta": [
        "Latn"
    ],
    "stb": [
        "Latn"
    ],
    "std": [
        "Zyyy"
    ],
    "ste": [
        "Latn"
    ],
    "stf": [
        "Latn"
    ],
    "stg": [
        "Latn"
    ],
    "sth": [
        "Latn"
    ],
    "sti": [
        "Latn"
    ],
    "stj": [
        "Latn"
    ],
    "stk": [
        "Latn"
    ],
    "stl": [
        "Latn"
    ],
    "stm": [
        "Latn"
    ],
    "stn": [
        "Latn"
    ],
    "sto": [
        "Latn"
    ],
    "stp": [
        "Latn"
    ],
    "stq": [
        "Latn"
    ],
    "str": [
        "Latn"
    ],
    "sts": [
        "Arab"
    ],
    "stt": [
        "Latn"
    ],
    "stu": [
        "Zyyy"
    ],
    "stv": [
        "Ethi",
        "Arab"
    ],
    "stw": [
        "Latn"
    ],
    "sty": [
        "Cyrl"
    ],
    "su": [
        "Latn",
        "Arab",
        "Java",
        "Sund"
    ],
    "sua": [
        "Latn"
    ],
    "sub": [
        "Latn"
    ],
    "suc": [
        "Latn"
    ],
    "sue": [
        "Latn"
    ],
    "sug": [
        "Latn"
    ],
    "sui": [
        "Latn"
    ],
    "suj": [
        "Latn"
    ],
    "suk": [
        "Latn"
    ],
    "suo": [
        "Latn"
    ],
    "suq": [
        "Latn",
        "Ethi"
    ],
    "sur": [
        "Latn"
    ],
    "sus": [
        "Latn",
        "Arab"
    ],
    "sut": [
        "Latn"
    ],
    "suv": [
        "Latn",
        "Beng",
        "Deva"
    ],
    "suw": [
        "Latn"
    ],
    "sux": [
        "Xsux"
    ],
    "suy": [
        "Latn"
    ],
    "suz": [
        "Deva"
    ],
    "sv": [
        "Latn",
        "Brai"
    ],
    "sva": [
        "Geor",
        "Cyrl",
        "Latn"
    ],
    "svb": [
        "Latn"
    ],
    "svc": [
        "Latn"
    ],
    "sve": [
        "Latn"
    ],
    "svk": [
        "Zxxx"
    ],
    "svm": [
        "Latn"
    ],
    "svs": [
        "Latn"
    ],
    "svx": [
        "Zyyy"
    ],
    "sw": [
        "Latn",
        "Arab"
    ],
    "swb": [
        "Arab",
        "Latn"
    ],
    "swc": [
        "Latn",
        "Arab"
    ],
    "swf": [
        "Latn"
    ],
    "swg": [
        "Latn"
    ],
    "swh": [
        "Arab",
        "Brai"
    ],
    "swi": [
        "Hani"
    ],
    "swj": [
        "Latn"
    ],
    "swk": [
        "Latn"
    ],
    "swl": [
        "Zxxx"
    ],
    "swm": [
        "Latn"
    ],
    "swn": [
        "Zyyy"
    ],
    "swo": [
        "Latn"
    ],
    "swp": [
        "Latn"
    ],
    "swq": [
        "Latn"
    ],
    "swr": [
        "Latn"
    ],
    "sws": [
        "Latn"
    ],
    "swt": [
        "Latn"
    ],
    "swu": [
        "Latn"
    ],
    "swv": [
        "Deva"
    ],
    "sww": [
        "Latn"
    ],
    "swx": [
        "Latn"
    ],
    "swy": [
        "Latn"
    ],
    "sxb": [
        "Latn"
    ],
    "sxc": [
        "Grek"
    ],
    "sxe": [
        "Latn"
    ],
    "sxg": [
        "Zyyy"
    ],
    "sxk": [
        "Zyyy"
    ],
    "sxl": [
        "Zyyy"
    ],
    "sxm": [
        "Zyyy"
    ],
    "sxn": [
        "Latn"
    ],
    "sxo": [
        "Zyyy"
    ],
    "sxr": [
        "Zyyy"
    ],
    "sxs": [
        "Latn"
    ],
    "sxu": [
        "Latn"
    ],
    "sxw": [
        "Latn"
    ],
    "sya": [
        "Latn"
    ],
    "syb": [
        "Latn"
    ],
    "syc": [
        "Syrc"
    ],
    "syi": [
        "Latn"
    ],
    "syk": [
        "Latn"
    ],
    "syl": [
        "Beng",
        "Latn",
        "Sylo"
    ],
    "sym": [
        "Latn"
    ],
    "syn": [
        "Syrc"
    ],
    "syo": [
        "Latn"
    ],
    "syr": [
        "Syrc"
    ],
    "sys": [
        "Latn"
    ],
    "syw": [
        "Deva"
    ],
    "syx": [
        "Latn"
    ],
    "syy": [
        "Zxxx"
    ],
    "sza": [
        "Latn"
    ],
    "szb": [
        "Latn"
    ],
    "szc": [
        "Latn"
    ],
    "szd": [
        "Latn"
    ],
    "sze": [
        "Zyyy"
    ],
    "szg": [
        "Latn"
    ],
    "szl": [
        "Latn"
    ],
    "szn": [
        "Latn"
    ],
    "szp": [
        "Latn"
    ],
    "szs": [
        "Latn",
        "Zxxx"
    ],
    "szv": [
        "Latn"
    ],
    "szw": [
        "Latn"
    ],
    "szy": [
        "Latn"
    ]
};
